import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  has_variant: false,
  selected_variants: [],
  variant_to_edit: null,
  category_id: null,
  file: null,
  form_values: {
    name_primary: "",
    name_secondary: "",
    description_primary: "",
    description_secondary: "",
    category: null,
    sub_category: null,
    catalogue: null,
    stock_quantity: "",
    buy_price: "",
    sell_price: "",
    brand_id: null,
    search_keywords: "",
    stock_alert: "",
    // Add fields for variant prices and stocks
    variant_stocks: {},
    variant_buy_prices: {},
    variant_sell_prices: {},
  },
  thumb_image: null,
  imageFiles: [],
  images: [],
  step: 1,
  combinations: [],
  isReEdited: false,
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setHasVariant: (state, action) => {
      state.has_variant = action.payload;
    },
    setSelectedVariants: (state, action) => {
      state.selected_variants = action.payload;
    },
    setVariantToEdit: (state, action) => {
      state.variant_to_edit = action.payload;
    },
    updateProductState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetProductState: () => initialState,
    updateFormValues: (state, action) => {
      state.form_values = { ...state.form_values, ...action.payload };
    },
    updateVariantValues: (state, action) => {
      const { field, values } = action.payload;
      state.form_values[field] = { ...state.form_values[field], ...values };
    },
  },
});

export const {
  setHasVariant,
  setSelectedVariants,
  setVariantToEdit,
  updateProductState,
  resetProductState,
  updateFormValues,
  updateVariantValues,
} = productSlice.actions;

export default productSlice.reducer;
